<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :get-action="queryApi"
      :query-params="queryParams"
      :col-span="colSpan"
      :label-width="'80px'"
      :before-reset-search="beforeResetSearch"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan" prop="cusId">
          <el-form-item>
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item prop="cusCode">
            <BjSelectLov v-model="queryParams.cusCode" :option-list="newClientCode" :placeholder="$t('billingPage.clientCode')" @change="handleQuery"/>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="addRate()">{{$t('createText')}}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'cusName'">
                <span class="link" @click="openCusName(scope.row)">{{ scope.row[col.prop]}}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <el-tag v-else-if="col.prop === 'isEnable'" :type="scope.row.isEnable ? 'success' : 'info'">
                {{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.isEnable)) }}
              </el-tag>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="addRate(props.row)">{{$t('copyText')}}</el-button>
              <el-button type="text" class="delete-btn" @click="delRate(props.row)">{{$t('delText')}}</el-button>
              <el-button type="text" @click="showLog(props.row)">{{ $t('logText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 列表页 新增、复制 弹窗 -->
    <el-dialog :visible.sync="dialogVisibleOne" width="500px" :before-close="handleClose1">
      <el-form ref="form1" :model="form1" status-icon :rules="rules1" label-position="top" label-width="100px">
        <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
          <BjSelectLov v-model="form1.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" @change="getUserInfo"/>
        </el-form-item>
        <el-form-item :label="$t('AccountManagementAdd.ps2')" prop="form1_validFromTo">
          <BjDateRangePicker v-model="form1_validFromTo" :placeholder="$t('AccountManagementAdd.ps2')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose1">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onConfirm()">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
    <!-- 侧边栏 / 一级侧边栏 -->
    <OutsideDrawer ref="OutsideDrawer" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
import { logisticApi, settingApi } from '@/api';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
import orderLog from '@/utils/log.js';
import OutsideDrawer from './components/OutsideDrawer.vue';
export default {
  name: 'BusinessLogisticsNewRateIndex',
  components: {
    OutsideDrawer,
    BjSelectCustomer,
  },
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      STATUS_ENABLED_NUM,
      queryApi: logisticApi.getLogisticNewRate,
      queryParams: {
        cusId: null,
        cusCode: null,
      },
      labelList: [
        {label: this.$t('billingPage.CustomerName'),prop: 'cusName',isCheck: true,disabled: false,},
        {label: this.$t('billingPage.clientCode'),prop: 'cusCode',isCheck: true,disabled: false,},
        {label: this.$t('WarehouseManagement.form.chooseLogistics'),prop: 'courier',isCheck: true,disabled: false,},
        {label: this.$t('billingPage.zoneGroup'),prop: 'zoneGroup',isCheck: true,disabled: false,},
        {label: 'businessLogisticsCompany.table.status',prop: 'isEnable',isCheck: true,disabled: false,},
        {label: this.$t('table.operationText'),prop: 'bjTableAction',isCheck: true,disabled: false,width: 160,},
      ],
      // 列表页 新增、复制 弹窗相关数据
      dialogVisibleOne:false,
      form1_validFromTo: [],
      form1:{
        cusId:null,
        startDate:null,
        endDate:null,
      },
    };
  },
  watch: {
    form1_validFromTo(v) {
      this.form1.startDate = (v || [])[0];
      this.form1.endDate = (v || [])[1];
    },
  },
  computed: {
    rules1() {
      const validateTime = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form1.startDate || !this.form1.endDate) {
            callback(new Error(this.$t('chooseText')));
          }
          callback();
        });
      };
      const rules = {
        cusId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        form1_validFromTo: [{ required: true, validator: validateTime, trigger: 'change' }],
      };
      return rules;
    },
    // 客户编码下拉
    newClientCode(){
      return this.clientCodeList.map(item=>{
        return{
          label:  item.clientCode,
          value: item.clientCode
        }
      })
    },
  },
  methods: {
    // 新增/复制
    addRate(row) {
      if(row){
        this.form1 = JSON.parse(JSON.stringify(row));
        this.form1_validFromTo = [row.startDate,row.endDate];
        this.dialogVisibleOne = true;
      }else{
        this.form1={
          cusId:null,
          startDate:null,
          endDate:null,
        }
        this.dialogVisibleOne = true;
      }
    },
    // 列表页弹窗关闭 清理数据
    handleClose1(){
      this.form1_validFromTo = []
      this.form1={ cusId:null, startDate:null, endDate:null }
      this.$refs['form1'].resetFields();
      this.dialogVisibleOne = false
    },
    // 列表页弹窗内 cusName cusCode 赋值
    getUserInfo(n,m){
      this.form1.cusName = m.cusName
      this.form1.cusCode = m.clientCode
    },
    // 列表页弹窗确认
    onConfirm(){
      this.$refs.form1.validate((valid) => {
        if(valid){
          if(this.form1.id){
            // 复制
            const POST_DATA = this.form1
            logisticApi.copyLogisticNewRate(POST_DATA).then(res=>{
              if(!res.failed){
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.handleClose1()
                  this.reFresh();
                }, 500);
              }
            })
          }else{
            // 新增
            const POST_DATA = {...this.form1,isEnable:1}
            logisticApi.addLogisticNewRate(POST_DATA).then(res=>{
              if(!res.failed){
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.handleClose1()
                  this.reFresh();
                }, 500);
              }
            })
          }
        }
      })
    },
    // 列表页删除物流费率
    delRate(row){
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        }).then(() => {
          logisticApi.delLogisticNewRate({ids: [row.id]}).then(res => {
            if(!res.failed){
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            }
          });
        })
    },
    // 打开一级侧边栏
    openCusName(row){
      this.$refs.OutsideDrawer.queryParams.customerConfigId = row.id
      this.$refs.OutsideDrawer.drawer = true
      this.$refs.OutsideDrawer.reFresh()
    },
    // 查看日志
    showLog(row) {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          `${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`,
          {
            actionApi: settingApi.logisticsLogList,
            defaultQuery: {
              recordId: row.id,
              // recordType: 'LOGISTICS PROVIDER',
            },
            columns: [
              {
                prop: 'createdName',
                label: 'BjDialogListConfig.Operator',
              },
              {
                prop: 'creationDate',
                label: 'BjDialogListConfig.Operationtime',
              },
              {
                prop: 'remark',
                label: 'BjDialogListConfig.Remarks',
              },
            ],
          },
        ),
      );
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams.cusId = null;
      this.queryParams.cusCode = null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-custom-class-body-div {
  max-height: calc(85vh - 120px);
  overflow-y: scroll;
}
::v-deep .bj-page .el-form-item__label {
  display: none;
}
</style>
